export default __webpack_public_path__ + "static/media/0.16443b27.png";